import {memo, useEffect, useState} from "react";
import OTPInput from "react-otp-input";

interface Props {
    inicialValue?: string;
    onCodeEntered?: (code: string) => void;
    loading?: boolean;
}

export const InputCode = memo(({loading, inicialValue, onCodeEntered}: Props) => {
    const [code, setCode] = useState(inicialValue || '');

    useEffect(() => {
        if (code.length === 6) {
            onCodeEntered && onCodeEntered(code);
        }
    }, [code]);

    useEffect(() => {
        setCode(inicialValue || '');
    }, [inicialValue]);

    return <OTPInput
        shouldAutoFocus
        inputStyle="inputStyle"
        value={code}
        onChange={setCode}
        numInputs={6}
        renderInput={(props) => <input disabled={loading} {...props} />}
    />;
});
